<template>
    <div class="query">
        <div class="title">
            <p class="return" @click="back">
                <img src="~@public/img/user/login/jian.png"/>
            </p>
            居住登记状态查询
        </div>
        <!--<van-field label="所属市州:" :value="value" placeholder="请选择" readonly is-link @click="showPicker = true"/>
        <van-field label="所属区县:" :value="value2" placeholder="请选择" readonly is-link @click="showPicker2 = true"/>-->
        <van-cell-group>
            <van-field v-model="handlingId" clearable label="身份证号:" placeholder="请输入身份证号"/>
            <!--<verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>-->
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="query">查询</van-button>
        </div>

        <div class="boxList" v-if="listShow">
            <div class="boxList-item">
                <span>身份证号:</span>
                <span>{{sfz}}</span>
            </div>
            <div class="boxList-item">
                <span>状态:</span>
                <span>正常</span>
            </div>
            <!--<div class="boxList-item">
                <span>可办理日期:</span>
                <span>2019.07.09</span>
            </div>-->
            <div class="boxList-item">
                <span>详细信息:</span>
                <span></span>
            </div>
        </div>
    </div>
</template>

<script>
    import {CellGroup, Field, Toast, Button} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {taskApiMap} from "@/api/task";
    import {queryApiMap} from "@/api/query";
    import { idCardRegex } from '@/utils/regex'

    export default {
        name: "ResigQuery",
        components: {
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button
        },
        data() {
            return {
                handlingId: '', // 身份证号
                zt: '', // 居住证状态
                sfz: '', // 身份证号码
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                value: '',
                showPicker: false,
                columns: ['杭州', '宁波', '温州', '嘉兴', '湖州'],
                listShow: false,
                dataList: []
            }
        },
        methods: {
            onConfirm(value) {
                this.value = value;
                this.showPicker = false;
            },
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },

            /**
             * 点击查询
             */
            async query() {
                if (!this.handlingId) {
                    Toast('请输入身份证号')
                } else if(!idCardRegex(this.handlingId)) {
                    Toast('请输入正确的身份证号')
                } /*else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                }*/ else {
                    try {
                        const res = await this.$httpUtils.getCommonUtils(`${queryApiMap.jzz}/${this.handlingId}`)
                        console.log(res)
                        if (res.data.data ) {
                           let info=JSON.stringify(res.data.data);
                            if(info.length>0) {
                                this.listShow=true;
                                var obj = new Function("return" + info)();
                                this.sfz= obj.sfzhm;
                            }else {
                                this.listShow = false
                                Toast.fail('暂无数据')
                            }
                        } else {
                            this.listShow=false;
                            Toast.fail('暂无数据')
                           // this.$refs.childFunction.interactionVerificationCode()
                        }
                    } catch (error) {
                        this.listShow=false;
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
<style>
    @import "~@assets/css/public/Common.css";
</style>

